<template>
    <div class="flex flex-col items-center justify-center h-full">
        <font-awesome-icon :icon="['far', 'spinner']" class="text-48px mr-2 text-gray-300 fa-spin" />
    </div>
</template>


<script>

export default {
    name: 'InboxBlankPlaceholder',
};

</script>

<style scoped>
div {
    min-height: 605px;
}
</style>